export default __webpack_public_path__ + "static/media/logo.fdfad458.svg";